// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation_navigation__24SuV","selected":"navigation_selected__2xU58"};